module.exports = __webpack_public_path__ + "img/gas-icon.783abf71.svg";